export {getHumanDuration} from "exports-loader?exports=getHumanDuration!common";
export {validateEmail} from "exports-loader?exports=validateEmail!common";

export const round = (value, precision) => {
    if (!precision) {
        return value;
    }
    const divider = Math.pow(10, precision);

    return Math.round(value * divider) / divider;
}

export const getClientNickname = (client, format) => {
	client = client || {};
	format = format || '{surname} {name} {patronymic}';

	if (client.nickname) {
		return client.nickname;
	}

	if (client.info && client.info.nickname) {
		return client.info.nickname;
	}

	return format
		.replace(/{([-_\w]+)}/gi, function(m, name) {
			let value = '';
			if(client[name]) {
				value = client[name];
			} else if(client.info && client.info[name]) {
				value = client.info[name];
			}
			return value;
		})
		.trim() || ('Зритель #' + client.id);
};

export const getClientLink = (client) => {
	client = client || {};

	if (client.link) {
		return client.link;
	}

	if (client.info && client.info.link) {
		return client.info.link;
	}

	return null;
};

export const getClientAvatar = (client) => {
	client = client || {};

	if (client.avatar) {
		return client.avatar;
	}

	if (client.info && client.info.avatar) {
		return client.info.avatar;
	}

	return '/player/images/avatar.svg';
};

export const copyToClipboard = (text, container) => {
	var e = document.createElement('textarea');
	container = container || document.body;
	container.appendChild(e);
	e.value = text;

	e.style.position = 'fixed';
	e.style.top = '-500px';
	e.style.left = '-500px';
	e.style.width = '200px';
	e.style.height = '200px';
	e.style.zIndex = 10000;

	e.focus();
	e.select();
	document.execCommand('copy');
	container.removeChild(e);
};
